// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface PlayIconSignature {
  Element: SVGSVGElement;
}

export const PlayIcon: TOC<PlayIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M19.985 11.741L5 20.482V3L19.985 11.741ZM16.015 11.741L7 6.482V17L16.015 11.741Z"/>
</svg>
</template>;